/**
 * EventType
 * (c) lg2fabrique 2016
 *
 */

export default class EventType {

    public static OPEN      = 'open';
    public static CLOSE     = 'close';

    public static COMPLETE  = 'complete';
    public static ERROR     = 'error';

    public static CLEAR     = 'clear';
    public static CHANGE    = 'change';
    public static UPDATE    = 'update';
    public static RENDER    = 'render';
    public static START     = 'start';
    public static STOP      = 'stop';
    public static READY     = 'ready';

    private _target         = null;

    constructor(
        private _type:string,
        private _data?:Object) {
    }

    public get type():string {
        return this._type;
    }
    public get data():any {
        return this._data;
    }

    public set target(value) {
        this._target = value;
    }
    public get target() {
        return this._target;
    }
}